import type React from 'react';
import { twMerge } from 'tailwind-merge';

import Icons from 'assets/icons';

export interface MessageInfoItemProps {
  message: string;
  className?: string;
  role?: 'status' | 'img';
}

const MessageInfoItem = ({
  message,
  className,
  role = 'status',
}: MessageInfoItemProps): React.JSX.Element => (
  <div
    role={role}
    aria-label={role === 'img' ? message : undefined}
    className={twMerge(
      'flex w-fit items-center gap-2 rounded-md border border-gray-300 bg-gray-50 px-3 py-4',
      className
    )}
  >
    <Icons.CellInfo aria-hidden customClass="size-5 shrink-0 text-gray-500" />
    <span className="text-base leading-6 text-gray-700">{message}</span>
  </div>
);

export default MessageInfoItem;
